"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CronjobHistorySortableColumns = void 0;
var CronjobHistorySortableColumns;
(function (CronjobHistorySortableColumns) {
    CronjobHistorySortableColumns["processDefinitionId"] = "processDefinitionId";
    CronjobHistorySortableColumns["processModelId"] = "processModelId";
    CronjobHistorySortableColumns["startEventId"] = "startEventId";
    CronjobHistorySortableColumns["crontab"] = "crontab";
    CronjobHistorySortableColumns["createdAt"] = "createdAt";
    CronjobHistorySortableColumns["executedAt"] = "executedAt";
})(CronjobHistorySortableColumns = exports.CronjobHistorySortableColumns || (exports.CronjobHistorySortableColumns = {}));
//# sourceMappingURL=CronjobHistory.js.map